import useDemoConfig from "./useDemoConfig";
import {AxisOptions, Chart} from "react-charts";
import {useMemo} from "react";

export default function MainChart({data}) {


    const primaryAxis = useMemo<
        AxisOptions<typeof data[number]["data"][number]>
    >(
        () => ({
            getValue: (datum) => datum.primary as unknown as Date,
        }),
        []
    );

    const secondaryAxes = useMemo<
        AxisOptions<typeof data[number]["data"][number]>[]
    >(
        () => [
            {
                getValue: (datum) => datum.secondary,
            },
        ],
        []
    );

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                padding: "12px",
                height: "400px",
            }}
        >
            <Chart
                options={{
                    data,
                    primaryAxis,
                    secondaryAxes,
                }}
            />
        </div>
    );
}